import { createContext, useContext } from 'react';

import type { CustomLanguage } from '@jane/bloom/types/schemas/bloom/customLanguage';

const defaultValue = {
  lineageLabels: null,
  productTypeLabels: {},
  reservationModeLabels: {
    curbside: 'Curbside pickup',
    delivery: 'Delivery',
    pickup: 'Pickup',
  },
  storeComplianceLanguageSettings: null,
};

export const CustomLanguageContext =
  createContext<CustomLanguage>(defaultValue);

export const useCustomLanguage = () => useContext(CustomLanguageContext);
